export const INVENTORY_BASE_URL = 'https://support.rentle.io/en/inventory';

export const CONNECT_TO_INVENTORY_ARTICLE_URL =
	'https://support.rentle.io/en/connecting-products-to-inventory';
